var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"OffWhiteBackground"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-title"},[_vm._v(" Shopping Cart ")])])])
}]

export { render, staticRenderFns }